import React, {useContext, useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import MainVenueConfig from './MainVenueConfig';
import {EventIntf} from "../ServerTypes";
import {useParams} from "react-router-dom";
import {MessageContext} from "../../MessageContext";
import PartyVenueConfig from "./PartyVenueConfig";
import EventAdminNav from "./EventAdminNav";


function Copyright() {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {'Copyright © '}
            <Link color="inherit" href="https://material-ui.com/">
                Your Website
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
    },
    layout: {
        width: 'auto',
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
            width: 600,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    paper: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
        padding: theme.spacing(2),
        [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
            marginTop: theme.spacing(6),
            marginBottom: theme.spacing(6),
            padding: theme.spacing(3),
        },
    },
    stepper: {
        padding: theme.spacing(3, 0, 5),
    },
    buttons: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    button: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(1),
    },
}));

function getStepContent(event: EventIntf, setValueSaver: (saver: () => string | null) => void) {
    if (event.venue === "MainVenue") {
        return <MainVenueConfig event={event} setValueSaver={setValueSaver}/>;
    } else if (event.venue === "PartyVenue") {
        return <PartyVenueConfig event={event} setValueSaver={setValueSaver}/>;
    } else {
        throw new Error('Unknown venue');
    }
}

export default function EventVenueConfig() {
    const [event, setEvent] = useState<EventIntf | null>(null)

    const messageContext = useContext(MessageContext)

    let valueSaver: () => string | null = () => null
    const setValueSaver = (s: () => string | null) => {
        valueSaver = s
    }

    const classes = useStyles();

    const {eventId} = useParams()

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_CALL}/events/${eventId}`, {
            credentials: 'include'
        })
            .then(response => response.json())
            .then(event => {
                setEvent(event)

            })
    }, [eventId])

    const handleNext = () => {
        const updated = valueSaver()
        if (updated) {
            fetch(`${process.env.REACT_APP_API_CALL}/events/${eventId}`, {
                method: "PATCH",
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                },
                body: JSON.stringify({
                    venueData: updated
                })
            })
                .then(response => response.json())
                .then(response => {
                    messageContext.showSuccessMessage("Event has been updated")
                })
        }
    };

    return event ? (
        <React.Fragment>
            <CssBaseline/>

            <EventAdminNav event={event}/>
            <main className={classes.layout}>
                <Paper className={classes.paper}>
                    <Typography component="h1" variant="h4" align="center">
                        Venue Data Config
                    </Typography>
                    <Typography variant="subtitle1">
                        Event-specific information to customize the venue.
                    </Typography>
                    <br/>
                    <React.Fragment>

                        {getStepContent(event, setValueSaver)}
                        <div className={classes.buttons}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleNext}
                                className={classes.button}
                            >
                                Save
                            </Button>
                        </div>

                    </React.Fragment>
                </Paper>
                <Copyright/>
            </main>
        </React.Fragment>
    ) : (
        <Typography component="h1" variant="h4" align="center">
            Loading
        </Typography>
    )
}
